import { render } from "./customer-service.vue?vue&type=template&id=47d496e4&scoped=true&ts=true"
import script from "./customer-service.vue?vue&type=script&lang=ts"
export * from "./customer-service.vue?vue&type=script&lang=ts"

import "./customer-service.vue?vue&type=style&index=0&id=47d496e4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d496e4"]])

export default __exports__